import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';

@Component({
  selector:    'pay-info-banner',
  standalone:  true,
  imports:     [CommonModule, LucideIconsModule],
  templateUrl: './pay-info-banner.component.html',
  styleUrls:   ['./pay-info-banner.component.scss'],
})
export class PayInfoBannerComponent {
  @Input() title:       string  = '';
  @Input() body?:       string;
  @Input() dismissible: boolean = true;
  @Input() icon:        string  = 'info';

  @Output() dismissed = new EventEmitter<void>();

  visible = true;

  dismiss(): void {
    this.visible = false;
    this.dismissed.emit();
  }
}
